import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { MainContainer } from "../components/container/MainContainer";
import { PageTitleContainer } from "../components/container/PageTitleContainer";
import EPDTable from "../sidemenu-pages/sidemenu-components/EPDTable";
import "../style/sidemenu-pages-style/StandardSuppliersLibrary.css";
import EPDLifeCycleAssessment from "./sidemenu-components/EPDLifeCycleAssessment";
import EPDPlot from "./sidemenu-components/EPDPlot";

function StandardSuppliersLibrary() {
  const [gwpValues, setGwpValues] = useState([]);
  const [isBoxplotView, setIsBoxplotView] = useState(false);

  const [firstSelectedRowData, setFirstSelectedRowData] = useState([]);
  useEffect(() => console.log(gwpValues), [gwpValues]);

  function calculateStandardDeviation(values) {
    if (values.length === 0) {
      return 0; // Return 0 or another default value when the array is empty
    }

    const mean = values.reduce((a, b) => a + b, 0) / values.length;
    return Math.sqrt(values.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b, 0) / values.length);
  }

  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Box>
            <Typography variant="Page Title">EPD Library</Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">EPD Library</Typography>
          </Box>
        </Box>
      </PageTitleContainer>
      <Box>
        {/* Pass the callback to EPDTable to update the parent's state */}
        <EPDTable
          setGwpValues={setGwpValues}
          setIsBoxplotView={setIsBoxplotView}
          calculateStandardDeviation={calculateStandardDeviation}
          setFirstSelectedRow={setFirstSelectedRowData}
        />

        {/* Conditionally render the EPDPlot based on isBoxplotView */}
        {isBoxplotView && <EPDPlot gwpValues={gwpValues} calculateStandardDeviation={calculateStandardDeviation} />}
      </Box>
      {firstSelectedRowData && (Array.isArray(firstSelectedRowData) ? firstSelectedRowData.length > 0 : true) && (
        <Box>
          <Box sx={{ paddingY: 2 }} />
          <EPDLifeCycleAssessment firstSelectedRowData={firstSelectedRowData} />
        </Box>
      )}
    </MainContainer>
  );
}

export default StandardSuppliersLibrary;
